export function createProsAndConsArray(prosList, consList) {
    const pros = {
        title: "Pros",
        body: prosList.map((item)=>item.text)
    };
    const cons = {
        title: "Cons",
        body: consList.map((item)=>item.text)
    };
    return [
        pros,
        cons
    ];
}
